import React from 'react';
import { Row, Col } from 'antd';
import './index.less';
import { GraphWrapper } from '@/components/Graph';
import { traffic7Days, keyEffect30Days } from '../../GraphConfig';
const isEmpty = (category, field) => {
    for (let i = 0; i < category.length; i++) {
        if (category[i][field].length === 0) {
            return true;
        }
    }
};
export default function TrafficBucketContent(props) {
    const { bucketParams = [], desc, traffic7DaysCfg, keyEffect30DaysCfg, } = props;
    const isTraffic7DaysEmpty = !traffic7DaysCfg.category ||
        traffic7DaysCfg.category.length === 0 ||
        isEmpty(traffic7DaysCfg.category, 'yAxis');
    return (<div className="traffic-bucket-content">
      <div className="traffic-bucket-content-box">
        <Row>
          {bucketParams.map((bucketParam) => (<Col span={12}>
              <span style={{
        width: 100,
        display: ' inline-block',
        textAlign: 'right',
    }}>
                {bucketParam[0]}
              </span>
              <span>{bucketParam[1]}</span>
            </Col>))}
        </Row>

        {desc && (<Row className="traffic-bucket-content-box-desc">描述：{desc}</Row>)}
      </div>

      <div className="traffic-bucket-content-graph">
        <GraphWrapper title="近7日流量比例" isEmpty={isTraffic7DaysEmpty} config={traffic7Days(traffic7DaysCfg)} className="traffic-bucket-content-graph-wrapper"/>

        <GraphWrapper title="近30日关键效果指标" isEmpty={!keyEffect30DaysCfg.yAxis || keyEffect30DaysCfg.yAxis.length === 0} config={keyEffect30Days(keyEffect30DaysCfg)} className="traffic-bucket-content-graph-wrapper"/>
      </div>
    </div>);
}
